import React, { useState } from "react";
import "./Home.css";
import "../../components/cards/Cards2.css";
import SideNav from "../../components/Navbar/SideNav";
import ContactSection from "../../components/contact/ContactSection";
import { NavLink } from "react-router-dom";

const Home = () => {
  return (
    <>
      <SideNav />
      <main>
        <section id="home-top">
          <div className="home-top container">
            <div className="home-top-left">
              <h1>Empowering a livable future</h1>
              <h3>
                In present situation of world, ICOESS is commited to provide
                adative services & solutions to our cusomers. ICOESS helps
                businesses thrive in a world defined by disruption and fueled by
                transformative technology.
              </h3>
              <NavLink className={"cta"} to={"technicalTraining"}>
                Our Technical Training
              </NavLink>
            </div>
            <div className="home-top-right">
              <video
                src="assets/videos/Intro.mp4"
                controls
                muted
                autoPlay
              ></video>
            </div>
          </div>
        </section>

        {/* Start Front Intro Section  */}
        <section className="article front-intro ">
          <div className="content">
            <h1 className="headline">Build your Web & Mobile Apps</h1>
            <p>
              Attractive Websites are doors of your Business. Our Team of
              Experts provides the custom build, Sophisticated & Full Featured
              Websites. Our Full Stack Developer team builds Robust Web
              Applications.
            </p>
            <p>
              Mobile app development is rapidly growing.Today, mobile
              devices—and the mobile applications that unlock their value—are
              the most popular way for people and businesses to connect to the
              internet.
            </p>
          </div>

          <figure className="image-wrap">
            <img src="assets/tech.jpg" alt="Shiv Shakti Gurukulam" />
          </figure>
        </section>
        {/* End Front Intro Section  */}

        {/* Start Home Services Section  */}
        <section id="home-services" className="main section-wrap">
          <div className="home-services ">
            <div className="home-services-header">
              <h1 className="section-title">
                Our <span>Services</span>
              </h1>
            </div>
            <div className="all-home-services">
              <div className="card2-item article">
                <div className="card2-info">
                  <h1>E-Commerce Development Services</h1>

                  <p>
                    We develop secure, scalable, and feature-rich e-commerce
                    solutions that help businesses sell products and services
                    online efficiently. Our services include custom online store
                    development, multi-vendor marketplace platforms, payment
                    gateway integration, inventory and order management systems,
                    customer account management, mobile-responsive design, SEO
                    optimization, third-party API integrations, and
                    performance-focused architecture. Whether you are launching
                    a new online business or expanding an existing one, we
                    create user-friendly e-commerce platforms that enhance
                    customer experience, streamline operations, and drive
                    business growth.
                  </p>
                  <NavLink to={"/products/misrow"} className="cta">
                    Know More...
                  </NavLink>
                </div>
                <div className="card2-img">
                  <img src="/heroSectionBanner.jpg" alt="img" />{" "}
                </div>
              </div>
              <div className="card2-item article">
                <div className="card2-info">
                  <h1>Web Development</h1>
                  <p>
                    We offer top-notch Web Development services to transform
                    your digital presence. Our expert team crafts responsive,
                    visually stunning, and highly functional websites tailored
                    to your specific needs. From e-commerce platforms to dynamic
                    web applications, we provide end-to-end solutions that
                    ensure a seamless user experience and drive your online
                    success. Trust us for innovative and efficient Web
                    Development that sets you apart in the digital landscape.
                  </p>
                  <NavLink to={"/webd"} className="cta">
                    Know More...
                  </NavLink>
                </div>
                <div className="card2-img">
                  <img src="assets/service/web.jpg" alt="img" />{" "}
                </div>
              </div>
              <div className="card2-item article">
                <div className="card2-info">
                  <h1>Mobile Apps</h1>

                  <p>
                    Our Company specializes in Mobile App Development, creating
                    dynamic and user-friendly applications for iOS and Android
                    platforms. Our team of skilled developers and designers
                    harness cutting-edge technology to bring your app ideas to
                    life. Whether it's a business app, game, or utility tool, we
                    tailor each solution to your unique requirements, ensuring a
                    seamless and engaging user experience. Elevate your mobile
                    presence with our Mobile App Development services and stay
                    ahead in the rapidly evolving digital landscape.
                  </p>
                  <NavLink to={"/mobiled"} className="cta">
                    Know More...
                  </NavLink>
                </div>
                <div className="card2-img">
                  <img src="assets/service/app.jpg" alt="img" />{" "}
                </div>
              </div>
              <div className="card2-item article">
                <div className="card2-info">
                  <h1>S/w Dev & OutSourcing</h1>

                  <p>
                    We offer top-notch Software Development & Outsourcing
                    services, providing customized solutions to meet your
                    software needs. Our expert team combines technical prowess
                    with a deep understanding of your business objectives to
                    deliver cost-effective and efficient software solutions.
                    Whether you need application development, maintenance, or
                    dedicated offshore development teams, we are your trusted
                    partner. Elevate your software capabilities and streamline
                    your operations with our Software Development & Outsourcing
                    services.
                  </p>
                  <NavLink to={"/SwDevOutsourcing"} className="cta">
                    Know More...
                  </NavLink>
                </div>
                <div className="card2-img">
                  <img src="assets/service/outsourcing.jpg" alt="img" />{" "}
                </div>
              </div>
              {/* <div className="card2-item article">
                <div className="card2-info">
                  <h1>IT Staffing & Smart Hire</h1>

                  <p>
                    Our Company specializes in IT Staffing & Smart
                    Hire services, helping businesses find the right talent for
                    their technological needs. Our smart hiring solutions
                    leverage data-driven approaches to identify the most
                    suitable candidates, saving you time and resources in the
                    recruitment process. Whether you require short-term contract
                    staff or long-term placements, we connect you with skilled
                    professionals who align with your company's goals and
                    culture. Elevate your IT team with our IT
                    Staffing & Smart Hire services and ensure a seamless fit for
                    your organization's success.
                  </p>
                  <NavLink to={"/itstaffing"} className="cta">
                    Know More...
                  </NavLink>
                </div>
                <div className="card2-img">
                  <img src="assets/service/itstaff/hiring.jpg" alt="img" />{" "}
                </div>
              </div> */}
              <div className="card2-item article">
                <div className="card2-info">
                  <h1>Technical Training</h1>

                  <p>
                    Corporate Technical Training by our Company is a tailored
                    learning program designed to empower organizations with
                    cutting-edge technical skills and knowledge. Our
                    comprehensive training solutions are crafted to enhance the
                    proficiency of your workforce, fostering innovation,
                    efficiency, and competitiveness. With experienced
                    instructors and customizable training modules, we ensure
                    that your team gains the expertise needed to excel in
                    today's rapidly evolving technological landscape. Elevate
                    your company's capabilities and stay ahead of the curve with
                    our Corporate Technical Training.
                  </p>
                  <NavLink to={"/technicalTraining"} className="cta">
                    Know More...
                  </NavLink>
                </div>
                <div className="card2-img">
                  <img src="assets/service/training.jpg" alt="img" />{" "}
                </div>
              </div>
              <div className="card2-item article">
                <div className="card2-info">
                  <h1>Education Support</h1>

                  <p>
                    We offers invaluable assistance to students, educators, and
                    institutions pursuing excellence in STEM education. Our
                    comprehensive support services encompass curriculum
                    development, teacher training, and technology integration,
                    enabling seamless and engaging learning experiences. With a
                    focus on Science, Computing, and Engineering (SCE), we
                    empower educators to inspire the next generation of
                    innovators and equip students with the skills they need for
                    a bright future. Elevate your educational initiatives with
                    our SCE Education Support.
                  </p>
                  <NavLink to={"/EducationSupport"} className="cta">
                    Know More...
                  </NavLink>
                </div>
                <div className="card2-img">
                  <img src="assets/service/education.jpg" alt="img" />{" "}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*  End Home Services Section */}

        {/*  Start Insights Section */}
        <section id="insights" className="insights-section container">
          <div className="flex insights-container container">
            <div className="insight-info">
              <h2 className="heading2">Insights</h2>
              <p className="paragraph">
                For ICOESS, insights are essential when it comes to defining
                strategies and driving actions. It helps drive our strategies to
                action. Periodically we have we well defined insights for our
                Marketing, IT Services, Technical Trainings, Recruitment &
                Staffing.
              </p>
            </div>
            <div className="insight-imgs row">
              <div className="grid_item center card-width">
                <div class="card">
                  <img src="assets/it sevice.jpg" alt="Project 1" />
                  <div class="card_content">
                    <h3>IT Services</h3>
                    <p>
                      Most important task of ICOESS has been customer
                      satisfaction. Here we came out as a extremely well in
                      terms of quality of service. Recently our customers have
                      shown extreme gratitude & satisfaction of our services.
                    </p>
                  </div>
                </div>
              </div>
              <div className="grid_item center card-width">
                <div class="card">
                  <img src="assets/skills.jpg" alt="Project 1" />
                  {/* <NavLink to=""> */}
                  <div className="div">
                    <div class="card_content">
                      <h3>
                        Upskilling India’s Talents
                        <br />
                        customised Technical Trainings
                      </h3>
                      <p>
                        In comparison to other developed & developming
                        countries, India has pools of young, enthusiastic,
                        technical workforce. We aim to bring this workforce with
                        “Low cost-Industry ready-Highly” upper surface and make
                        them industry ready to serve industry & country.
                      </p>
                    </div>
                  </div>
                  {/* </NavLink> */}
                </div>
              </div>
              <div className="grid_item center card-width">
                <div class="card">
                  <img src="assets/itt.jpg" alt="Project 1" />
                  {/* <NavLink to="/about"> */}
                  <div class="card_content">
                    <h3>Marketing Strategy of ICOESS</h3>
                    <p>
                      We service client across various industries <br />
                      including Health care, manufacturing, retail etc. We know
                      that promotion plays a significant role when it comes to
                      the growth of the company. ICOESS has a plan to make a
                      strong presence through its Website & Social Media
                      Channels etc.
                    </p>
                  </div>
                  {/* </NavLink> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*  End Insights Section



        {/*  Start Service Areas Section */}
        <section id="service-areas" className="service-areas section container">
          <h1 className="section-title">
            Our Service <span>Areas</span>
          </h1>
          <div className="column">
            <div className="row jcsb flex-wrap" id="flex-row-box">
              <div id="service-area-card" className="course-item item1 wh-150 ">
                <p className="service-area-paragraph">Health Care</p>
              </div>
              <div className="course-item item2 wh-150 ">
                <p className="service-area-paragraph">Ecommerce Solutions</p>
              </div>
              <div className="course-item item3 wh-150 ">
                <p className="service-area-paragraph">Training and Education</p>
              </div>

              <div className="course-item item4 wh-150 ">
                <p className="service-area-paragraph">Real Estate</p>
              </div>
            </div>
            <div className="row jcsb flex-wrap" id="flex-row-box">
              <div className="course-item item5 wh-150 ">
                <p className="service-area-paragraph">IT Project Management</p>
              </div>
              <div className="course-item item6 wh-150 ">
                <p className="service-area-paragraph">AI and ML Services</p>
              </div>

              <div className="course-item item7 wh-150 ">
                <p className="service-area-paragraph">IT Consulting</p>
              </div>
              <div className="course-item item8 wh-150 ">
                <p className="service-area-paragraph">Custom Softwares</p>
              </div>
            </div>
          </div>
        </section>
        {/*  End Service Areas Section */}

        {/*  Start inside icoess Section */}
        <section id="inside-icoess" className=" inside-icoess container ">
          <div className="flex insights-container container">
            <div className="insight-info">
              <h2 className="heading2">Inside ICOESS</h2>
              <p>
                At ICOESS, we're not Just writting code; we're Shaping the
                future! Join us on a Journey of innovation, where every line of
                code has the Power to make a difference.
              </p>
            </div>
            <div className="insight-imgs row ">
              <div className="work work-insight">
                <div className="grid_item card-width">
                  <div className="inside-icoess-card">
                    <div className="image_container eachdiv">
                      <img
                        src="assets/insideicoess/inn.png"
                        alt="web development"
                      />
                    </div>
                    <div className="inside-icoess-card_content">
                      <h3>Innovation with impact</h3>
                      <p>
                        We believe in the strength of collaboration Together, we
                        achieve more. your ideas matter, and your Voice Shapes
                        our Success.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="grid_item card-width">
                  <div className="inside-icoess-card">
                    <div className="image_container eachdiv">
                      <img
                        src="assets/insideicoess/global.jpg"
                        alt="web development"
                      />
                    </div>
                    <div className="inside-icoess-card_content">
                      <h3>Global impact</h3>
                      <p>
                        Join us in creating Software that transcends boundaries.
                        Contribute to Project with a global footprint and be a
                        part of something meaningful.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="grid_item card-width">
                  <div className="inside-icoess-card">
                    <div className="image_container eachdiv">
                      <img
                        src="assets/insideicoess/customer centric.jpg"
                        alt="web development"
                      />
                    </div>
                    <div className="inside-icoess-card_content">
                      <h3>Client-Centric Impact</h3>
                      <p>
                        our solutions resonate globally, contibute to projects
                        that have a tangile impact on client, fostering
                        long-term relationship and trust.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*  End inside icoess Section */}

        {/* Start About Us Section  */}
        {/* End About Us Section  */}

        {/*  Start Contact Section */}
        <div className="" id="home-contact-section">
          <ContactSection
            text={
              "Talk to us for your business needs, all staffing requirements and anything on technology. We would love to here from you & share our expertise with you"
            }
          />
        </div>
        {/*  End Contact Section */}
      </main>
    </>
  );
};

export default Home;
